import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { colors as C, fonts as F } from '../theme'
import { useIsMobile } from '../hooks/useIsMobile'

export default function MentionsLegalesPage() {
  const isMobile = useIsMobile()
  return (
    <div style={{ background: C.bgPage, minHeight: '100vh' }}>
      {/* Header */}
      <header style={{
        background: C.bgCard,
        borderBottom: `0.5px solid ${C.border}`,
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: '1rem 2rem',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: C.textPrimary,
            textDecoration: 'none',
            fontSize: '0.9rem',
            fontWeight: 500,
          }}>
            <ChevronLeft size={20} />
            Retour
          </Link>
          <div style={{
            fontSize: '1.2rem',
            fontFamily: F.serif,
            fontWeight: 400,
            color: C.textPrimary,
          }}>
            IAvocat<span style={{ fontStyle: 'italic', color: C.accent }}>.ai</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div style={{
        maxWidth: '760px',
        margin: '0 auto',
        padding: isMobile ? '32px 18px' : '60px 24px',
        background: C.bgCard,
        minHeight: '100vh',
      }}>
        <h1 style={{
          fontFamily: F.serif,
          fontSize: isMobile ? '28px' : '36px',
          fontWeight: 400,
          color: C.textPrimary,
          marginBottom: '0.5rem',
        }}>
          Mentions Légales
        </h1>
        <p style={{
          fontFamily: F.sans,
          fontSize: '12px',
          fontStyle: 'italic',
          color: C.textSecondary,
          marginBottom: '2rem',
        }}>
          Dernière mise à jour : 20 avril 2026
        </p>

        <div style={{ fontFamily: F.sans, lineHeight: 1.8, color: C.textSecondary }}>

          {/* Section 1 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              1. Éditeur du Site
            </h2>
            <p>
              Le présent site internet est édité par :
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '1rem',
            }}>
              <p><strong>MY LEGAL ACT INFORMATION TECHNOLOGY CONSULTANTS - FZCO</strong> <span style={{ fontStyle: 'italic' }}>(ci-après « My Legal Act »)</span></p>
              <p style={{ marginTop: '0.5rem' }}>Forme juridique : Free Zone Company (FZCO) de droit émirien</p>
              <p style={{ marginTop: '0.5rem' }}>Licence n° 66207, délivrée le 11 juillet 2025 par la Dubai Integrated Economic Zones Authority (DIEZ), au sein de l'International Free Zone Authority (IFZA)</p>
              <p style={{ marginTop: '0.5rem' }}>Enregistrement n° 64173</p>
              <p style={{ marginTop: '0.5rem' }}>Siège social : IFZA Properties, DSO-IFZA, Dubai Silicon Oasis, Dubai, Émirats Arabes Unis</p>
              <p style={{ marginTop: '0.5rem' }}>TRN (VAT) : 105094023600001</p>
              <p style={{ marginTop: '0.5rem' }}>Makani N° : A1 - 3641379065</p>
              <p style={{ marginTop: '0.5rem' }}>Email : contact@iavocat.ai</p>
            </div>
          </section>

          {/* Section 2 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              2. Directeur de la Publication
            </h2>
            <p>
              Directeur de la publication : <strong>le représentant légal de MY LEGAL ACT INFORMATION TECHNOLOGY CONSULTANTS - FZCO</strong>.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Il est responsable du contenu du site conformément à la loi.
            </p>
          </section>

          {/* Section 2bis — Représentant UE (Article 27 RGPD) */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              2 bis. Représentant dans l'Union européenne
            </h2>
            <p>
              En application de l'article 27 du Règlement (UE) 2016/679 (RGPD), l'éditeur, qui est établi
              hors de l'Union européenne, a désigné le représentant suivant pour l'ensemble des questions
              relatives à la protection des données personnelles des utilisateurs établis dans l'UE :
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '1rem',
            }}>
              <p>Un prestataire de représentation établi dans l'Union européenne est en cours de désignation. Ses coordonnées complètes seront publiées sur la présente page dès sa désignation.</p>
              <p style={{ marginTop: '0.5rem' }}>Dans l'intervalle, toute demande relative à la protection des données personnelles peut être adressée à : privacy@iavocat.ai</p>
            </div>
            <p style={{ marginTop: '1rem', fontSize: '13px', fontStyle: 'italic' }}>
              Toute personne concernée par un traitement peut s'adresser à ce représentant pour exercer
              ses droits ou pour toute demande liée à la protection des données.
            </p>
          </section>

          {/* Section 3 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              3. Hébergement et sous-traitants
            </h2>
            <p>
              Le site et les services sont fournis avec le concours des sous-traitants suivants, dont le détail et les garanties sont décrits dans la Politique de Confidentialité :
            </p>
            <p style={{ marginTop: '1rem' }}>
              <strong>Frontend (Interface Web)</strong>
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '0.8rem',
            }}>
              <p>Vercel Inc. (États-Unis)</p>
            </div>

            <p style={{ marginTop: '1.5rem' }}>
              <strong>Backend (Base de Données et Authentification)</strong>
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '0.8rem',
            }}>
              <p>Supabase (infrastructure AWS, région eu-west-1 Irlande, UE)</p>
            </div>

            <p style={{ marginTop: '1.5rem' }}>
              <strong>Modèles d'intelligence artificielle</strong>
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '0.8rem',
            }}>
              <p>Anthropic PBC (États-Unis, sous conditions de l'accord de traitement et de l'hébergement UE détaillés dans la Politique de Confidentialité)</p>
            </div>

            <p style={{ marginTop: '1.5rem' }}>
              <strong>OCR (Reconnaissance de caractères sur documents scannés)</strong>
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '0.8rem',
            }}>
              <p>Amazon Web Services, AWS Textract, région eu-central-1 (Frankfurt, UE)</p>
            </div>

            <p style={{ marginTop: '1.5rem' }}>
              <strong>Paiement</strong>
            </p>
            <div style={{
              background: C.bgPage,
              padding: '1.5rem',
              borderRadius: '8px',
              marginTop: '0.8rem',
            }}>
              <p>Stripe Payments Europe Ltd. (Irlande, UE)</p>
            </div>

            <p style={{ marginTop: '1rem' }}>
              La liste complète et à jour des sous-traitants, ainsi que les garanties associées, figurent dans la Politique de Confidentialité.
            </p>
          </section>

          {/* Section 4 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              4. Propriété Intellectuelle
            </h2>
            <p>
              Tous les contenus du site (textes, images, graphiques, logos, icônes, vidéos, fichiers, et structure) sont la propriété exclusive de My Legal Act ou sont utilisés avec autorisation.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Toute reproduction, distribution ou exploitation sans autorisation écrite est interdite et peut donner lieu à des poursuites judiciaires.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Les signes distinctifs « iavocat.ai », les logos associés et la charte graphique sont protégés par le droit d'auteur et par le droit des signes distinctifs, qu'ils fassent ou non l'objet d'un dépôt à titre de marque.
            </p>
          </section>

          {/* Section 5 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              5. Responsabilité de l'Éditeur
            </h2>
            <p>
              My Legal Act s'efforce d'assurer l'exactitude et la mise à jour des informations disponibles sur le site. Toutefois, elle ne garantit pas l'absence d'erreurs ou l'adéquation du contenu à vos besoins spécifiques.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              L'utilisation du site et des services d'IA qui y sont fournis est à votre entière responsabilité. My Legal Act ne peut être tenue responsable des erreurs, omissions ou préjudices découlant de l'utilisation des contenus ou de l'IA.
            </p>
          </section>

          {/* Section 6 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              6. Accès et Disponibilité du Site
            </h2>
            <p>
              My Legal Act s'efforce de maintenir le site accessible 24h/24. Cependant, elle ne garantit pas une disponibilité ininterrompue. Le site peut être indisponible pour raisons de maintenance, mise à jour technique, ou circonstances indépendantes de sa volonté.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Aucune responsabilité ne peut être engagée en cas d'indisponibilité du site ou des services.
            </p>
          </section>

          {/* Section 7 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              7. Liens Hypertextes
            </h2>
            <p>
              Le site peut contenir des liens vers des sites externes. My Legal Act n'est pas responsable du contenu de ces sites externes et ne les cautionne pas nécessairement.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Si vous disposez d'un site et souhaitez créer un lien vers IAvocat.ai, vous pouvez le faire librement, à condition de ne pas dénaturer ou critiquer le site ou ses services.
            </p>
          </section>

          {/* Section 8 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              8. Données Personnelles
            </h2>
            <p>
              Le traitement des données personnelles est régi par la <strong>Politique de Confidentialité</strong> disponible sur le site.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              En accédant et utilisant le site, vous acceptez le traitement de vos données conformément à cette politique.
            </p>
          </section>

          {/* Section 9 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              9. Conditions Générales d'Utilisation et de Vente
            </h2>
            <p>
              L'accès et l'utilisation du site sont régis par les <Link to="/cgu" style={{ color: C.accent, textDecoration: 'underline' }}>Conditions Générales d'Utilisation</Link> disponibles sur le site. En accédant au site, vous acceptez sans restriction ces conditions.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              La souscription et le paiement des abonnements sont régis par les <Link to="/cgv" style={{ color: C.accent, textDecoration: 'underline' }}>Conditions Générales de Vente</Link>.
            </p>
          </section>

          {/* Section 10 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              10. Droit Applicable et Juridiction
            </h2>
            <p>
              Les présentes mentions légales sont régies par le droit français.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Les litiges relatifs à la protection des données personnelles relevant du Règlement (UE) 2016/679 peuvent être portés, au choix de la personne concernée, devant l'autorité de contrôle ou la juridiction compétente du lieu du représentant dans l'Union européenne de l'Éditeur.
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Les autres litiges relatifs à l'utilisation du site ou aux services fournis sont soumis aux règles de compétence juridictionnelle applicables, notamment le Règlement (UE) 1215/2012 du 12 décembre 2012 (« Bruxelles I bis »).
            </p>
          </section>

          {/* Section 11 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              11. Signalement d'Abus
            </h2>
            <p>
              Si vous découvrez du contenu illégal, contraire à l'éthique ou qui viole vos droits, veuillez le signaler immédiatement à :
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              <strong>contact@iavocat.ai</strong>
            </p>
            <p style={{ marginTop: '0.8rem' }}>
              Mentionnez « Signalement abus » dans le sujet de votre message.
            </p>
          </section>

          {/* Section 12 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              12. Modification des Mentions Légales
            </h2>
            <p>
              My Legal Act se réserve le droit de modifier ces mentions légales à tout moment. Les modifications prennent effet immédiatement après leur publication sur le site.
            </p>
          </section>

          {/* Section 13 */}
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: 500,
              color: C.textPrimary,
              marginBottom: '1rem',
            }}>
              13. Conformité Légale
            </h2>
            <p>
              La Plateforme IAvocat.ai est conçue pour assister les avocats inscrits au barreau français. Elle est conforme à :
            </p>
            <ul style={{ marginLeft: '1.5rem', marginTop: '0.8rem' }}>
              <li>La loi Informatique et Libertés (L. 78-17 du 6 janvier 1978)</li>
              <li>Le Règlement Général sur la Protection des Données (RGPD, UE 2016/679)</li>
              <li>Le Code de l'organisation judiciaire et le secret professionnel</li>
              <li>Le respect, par l'avocat utilisateur, des obligations de lutte contre le blanchiment de capitaux et le financement du terrorisme (LCB-FT) qui lui sont applicables au titre du Code monétaire et financier</li>
            </ul>
          </section>

          <hr style={{ margin: '2.5rem 0', border: 'none', borderTop: `0.5px solid ${C.border}` }} />

          <p style={{ fontSize: '0.9rem', color: C.textSecondary, marginTop: '2rem' }}>
            Pour toute question ou demande concernant ces mentions légales, contactez-nous à contact@iavocat.ai.
          </p>
        </div>
      </div>
    </div>
  )
}
